var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckstatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00027 9.49025H7.00588M1.38623 3.21371C2.93015 1.83278 4.92888 1.06934 7.00027 1.06934C9.07166 1.06934 11.0704 1.83278 12.6143 3.21371M3.07044 5.4813C4.11987 4.45266 5.53078 3.87649 7.00027 3.87649C8.46976 3.87649 9.88067 4.45266 10.9301 5.4813M5.03535 7.4855C5.56007 6.97118 6.26552 6.6831 7.00027 6.6831C7.73501 6.6831 8.44047 6.97118 8.96518 7.4855",
    stroke: "white",
    strokeWidth: 1.26316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckstatus);
export default __webpack_public_path__ + "static/media/checkstatus.ff9d5910199f6e0f3eb9a71bc4da0b5e.svg";
export { ForwardRef as ReactComponent };